var exports = {
  "vR": "xdde3148b--de0f99--tabs",
  "Mf": "xdde3148b--de0f99--tab",
  "DD": "xdde3148b--de0f99--title",
};

module.exports = exports;
